import $ from 'jquery';
import '@fontsource/crimson-text';
import '@fontsource-variable/roboto-condensed';

import LangSelector from './components/lang-selector';
import SiteHeader from './components/site-header';
import HandheldMenu from './components/handheld-menu';
import { AccordionDef } from './components/accordion';
import ScrollInView from './components/scroll-in-view';
import { Lightbox } from './components/lightbox';

import DeviceManager from './utils/device-manager';
import { Filter } from './components/Filter';
import { handleFilter, handleFilterSearch } from './components/handleFilter';
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

// (function ($) {
// window.$ = $;

$(function () {
	const bootstrapApp = () => {
		const $html = $('html');

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass('touch');

			if (DeviceManager.isIos()) {
				$html.addClass('ios');
			}
		} else {
			$html.addClass('no-touch');
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass('ie11');
		} else if (DeviceManager.isEdge()) {
			$html.addClass('edge');
		}
	};

	const instanciateComponents = () => {
		// General components
		const langSelector = new LangSelector($('.language-selector'));
		const siteHeader = new SiteHeader($('.site-header'), 20);

		const $reviewsSlider = $('.reviews-slider');
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// Scroll in view component
		const $scrollInViewElements = $('.scroll-in-view');
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	};

	bootstrapApp();
	instanciateComponents();
});

// })(jQuery);

const readMore = document.querySelector('.read-more__layout');
const menuToggler = document.querySelector('.menu-toggler');
const menu = document.querySelector('.header__nav-wrapper');

if (menuToggler && menu) {
	menuToggler.addEventListener('click', () => {
		menu.classList.toggle('menu--opened');
		menuToggler.classList.toggle('menu-toggler--opened');
	});
}

if (readMore) {
	const readMoreContent = document.querySelector('.read-more__content-wrapper');
	const readMoreContentHeight = readMoreContent.offsetHeight;
	const readMoreBtn = document.querySelector('#read-more-btn');
	const readLessBtn = document.querySelector('#read-less-btn');

	if (readMoreContentHeight > 500) {
		// console.log("Contenu supérieur à 500px, ajout du bouton");
		readMoreContent.style.height = '500px';
		readMoreContent.style.overflow = 'hidden';

		readMoreBtn.addEventListener('click', () => {
			readMoreContent.style.height = `auto`;
			readLessBtn.style.display = 'inline-block';
			readMoreBtn.style.display = 'none';
		});
		readLessBtn.addEventListener('click', () => {
			readMoreContent.style.height = '500px';
			readMoreBtn.style.display = 'inline-block';
			readLessBtn.style.display = 'none';
			readMore.scrollIntoView();
		});
	} else {
		// console.log("Contenu inférieur à 500px, suppression du bouton");
		readMoreBtn.style.display = 'none';
		readLessBtn.style.display = 'none';
	}
}

const details = document.querySelectorAll('details');

if (details) {
	details.forEach((el) => {
		if (!el.classList.contains('filter-detail')) {
			new AccordionDef(el);
		}
	});
}

const gallery = document.querySelector('.galerie__layout');
if (gallery) {
	Lightbox.init(gallery);
	const images = Array.from(gallery.querySelectorAll('a'));
	const sejour = document.querySelector('.sejour-container');
	if (sejour) {
		if (images.length > 4) {
			const more = document.createElement('div');
			const hiddenImageCounter = images.length - 4;
			more.textContent = `+ ${hiddenImageCounter}`;
			more.classList.add('galerie__more');
			images[3].appendChild(more);
			images.forEach((img, index) => {
				if (index > 3) {
					img.style.display = 'none';
				}
			});
		}
	} else {
		if (images.length > 6) {
			const more = document.createElement('div');
			const hiddenImageCounter = images.length - 6;
			more.textContent = `+ ${hiddenImageCounter}`;
			more.classList.add('galerie__more');
			images[5].appendChild(more);
			images.forEach((img, index) => {
				if (index > 5) {
					img.style.display = 'none';
				}
			});
		}
	}
}

const detailSejourHeadings = document.querySelectorAll(
	'.detail-sejour__headings li'
);

const detailSejourContent = document.querySelectorAll(
	'.detail-sejour__content .detail-sejour__content-tab'
);

const detailSejourContentBtn = document.querySelectorAll(
	'.detail-sejour__content .detail-sejour__content-btn-mobile'
);

if (detailSejourHeadings.length > 0 && detailSejourContent.length > 0) {
	detailSejourHeadings.forEach((heading, index) => {
		heading.addEventListener('click', () => {
			detailSejourHeadings.forEach((h) => {
				h.classList.remove('active');
			});
			detailSejourContent.forEach((content) => {
				content.classList.remove('active');
			});
			heading.classList.add('active');
			detailSejourContent[index].classList.add('active');
		});
	});
	detailSejourContentBtn.forEach((btn, index) => {
		btn.addEventListener('click', () => {
			detailSejourContent.forEach((content) => {
				content.classList.remove('active');
			});
			// btn.classList.add('active');
			detailSejourContent[index].classList.add('active');
		});
	});
}

const sejourPage = document.querySelector('.sejours-archive__container');

if (sejourPage) {
	const filtersContainer = sejourPage.querySelector('.filters-container');

	if (filtersContainer) {
		const details = filtersContainer.querySelectorAll('details');
		let events = [];
		details.forEach((detail) => {
			events.push(new Filter(detail));
		});

		const cardsContainer = document.querySelector('.cards-container');
		handleFilter(cardsContainer, []);
		const showMoreCards = document.getElementById('show-more-sejour');
		const filterBtns = document.querySelectorAll('.filter-btn');
		const resetFilterBtns = document.querySelectorAll('.reset');

		if (cardsContainer && showMoreCards) {
			const cards = cardsContainer.querySelectorAll('.card');
			const resultNumber = document.getElementById('result-number');

			if (resultNumber) {
				if (window.location.search) {
					let cardShown = 0;
					cards.forEach((card) => {
						if (!card.classList.contains('unmatch')) {
							cardShown++;
						}
					});
					resultNumber.textContent = `${cardShown} résultats`;
				} else {
					resultNumber.textContent = `${cards.length} résultats`;
				}
			}

			let currentIndex = 8;

			const updatePaginationForFiltered = () => {
				const matched = Array.from(cards).filter(
					(c) => !c.classList.contains('unmatch')
				);
				cards.forEach((c) => c.classList.remove('show'));
				matched.forEach((c, idx) => {
					if (idx <= currentIndex) c.classList.add('show');
				});
				if (matched.length <= currentIndex + 1) {
					showMoreCards.style.display = 'none';
				} else {
					showMoreCards.style.display = 'flex';
				}
			};

			updatePaginationForFiltered();

			showMoreCards.addEventListener('click', () => {
				const matched = Array.from(cards).filter(
					(c) => !c.classList.contains('unmatch')
				);
				if (currentIndex + 1 < matched.length) {
					currentIndex = currentIndex + 9;
					updatePaginationForFiltered();
				}
			});

			let filters = [];
			for (const filterBtn of filterBtns) {
				filterBtn.addEventListener('click', () => {
					const noResults = document.querySelector('.no-results');
					if (noResults) {
						noResults.remove();
					}
					// Rebuild filters from current selections each time the user clicks Filter
					filters = [];
					events.forEach((event) => {
						filters.push(event.returningFilter());
					});
					handleFilter(cardsContainer, filters);
					currentIndex = 8;
					updatePaginationForFiltered();
					let showCards = 0;
					cards.forEach((card) => {
						if (!card.classList.contains('unmatch')) {
							showCards++;
						}
					});
					if (resultNumber) {
						resultNumber.textContent = `${showCards} résultats`;
					}
				});
			}

			for (const resetFilterBtn of resetFilterBtns) {
				resetFilterBtn.addEventListener('click', () => {
					const noResults = document.querySelector('.no-results');
					if (noResults) {
						noResults.remove();
					}
					let url = window.location.href;
					window.history.pushState({}, '', `${url.split('?')[0]}`);
					events.forEach((event) => {
						filters = [];
						cardsContainer.querySelectorAll('.card').forEach((card) => {
							card.classList.remove('unmatch');
						});
						event.resetFilters();
						// Close accordions after reset (no active filters)
						if (typeof event.setInitialOpenState === 'function') {
							event.setInitialOpenState();
						}
					});
					currentIndex = 8;
					updatePaginationForFiltered();
					showMoreCards.style.display = 'flex';
					if (resultNumber) {
						resultNumber.textContent = `${cards.length} résultats`;
					}
				});
			}
		}
	}
}

const mainMenu = document.getElementById('main-menu');
const menuItems = mainMenu.querySelectorAll('.menu-item');
const hoverBar = document.querySelector('.hover-bar');
const hoverElement = hoverBar.querySelector('.hover-element');

if (mainMenu && menuItems && hoverBar && hoverElement) {
	const mainMenuRect = mainMenu.getBoundingClientRect();

	hoverElement.style.left = `${mainMenuRect.left + window.scrollX}px`;

	mainMenu.addEventListener('mouseleave', () => {
		hoverBar.style.opacity = '0';
		hoverElement.style.left = `${mainMenuRect.left + window.scrollX}px`;
	});
	menuItems.forEach((item) => {
		item.addEventListener('mouseover', (e) => {
			hoverBar.style.opacity = '1';
			const rect = item.getBoundingClientRect();
			const position = rect.left + rect.width / 2 - 21 / 2;
			hoverElement.style.left = `${position + window.scrollX}px`;
		});
	});
}

const arrowAnimated = document.getElementById('arrow-anim');
const initArrowAnimation = (isOpen = false) => {
	const firstPathD = 'M8 8L8 34';
	const secondPathD = 'M4 34L8 38L12 34';
	const firstPathDInit = 'M8 8L8 15';
	const secondPathDInit = 'M4 15L8 19L12 15';
	const animatedHeight = 46;
	const initialHeight = 27;

	if (!isOpen) {
		arrowAnimation(
			arrowAnimated,
			firstPathD,
			secondPathD,
			animatedHeight,
			5000,
			false
		);
	} else {
		arrowAnimation(
			arrowAnimated,
			firstPathDInit,
			secondPathDInit,
			initialHeight,
			2000,
			true
		);
	}
};

const arrowAnimation = (
	element,
	firstPath,
	secondPath,
	height,
	duration,
	initHasOpen
) => {
	const rect = element.querySelector('rect');
	const path = element.querySelectorAll('path');

	if (!initHasOpen) {
		setTimeout(() => {
			rect.setAttribute('height', height - 1);
			path[0].setAttribute('d', firstPath);
			path[1].setAttribute('d', secondPath);
		}, duration - 500);

		setTimeout(() => {
			rect.setAttribute('height', height - 2);
			path[0].setAttribute('d', 'M8 8L8 32');
			path[1].setAttribute('d', 'M4 32L8 36L12 32');
		}, duration - 250);
	}

	setTimeout(() => {
		rect.setAttribute('height', height - 1);
		path[0].setAttribute('d', firstPath);
		path[1].setAttribute('d', secondPath);
		if (initHasOpen) return;
		initArrowAnimation(!initHasOpen);
	}, duration);
};

if (arrowAnimated) {
	setInterval(initArrowAnimation, 6000);
}

const frontSearch = document.querySelector('.search-sejour');

if (frontSearch) {
	const link = frontSearch.querySelector('button');
	const filters = document.querySelectorAll('.filter-container');

	link.addEventListener('click', (e) => {
		e.preventDefault;
		const href = window.location.href + '/sejour';
		window.location.href = `${href}?ages=${filters[0].querySelector('select').value}&destinations=${filters[1].querySelector('select').value}&periode=${filters[2].querySelector('select').value}`;
	});
}

const splide = document.querySelector('.slider-container');
const teamSlider = document.querySelector('.team-slider');
const testimoniesSlider = document.querySelector('.testimonies-slider');
const videoCarousel = document.querySelector('.video-carousel');

if (splide) {
	new Splide(splide, {
		type: 'fade',
		autoplay: true,
		interval: 5000,
		rewind: true,
	}).mount();
}

if (teamSlider) {
	const slides = teamSlider.querySelectorAll('.splide__list li');

	if (slides) {
		slides.forEach((element) => {
			element.addEventListener('click', (e) => {
				slides.forEach((el) => (el.style.transform = 'scale(1)'));
				e.target.style.transform = 'scale(1.2)';
			});
		});
	}

	new Splide(teamSlider, {
		type: 'slide',
		rewind: true,
		autoplay: true,
		interval: 5000,
		perPage: 2,
		gap: '4.8rem',
		mediaQuery: 'min',
		padding: 0,
		breakpoints: {
			620: {
				perPage: 3,
			},
			768: {
				perPage: 4,
			},
			992: {
				perPage: 5,
				gap: '5.4rem',
			},
			1200: {
				perPage: 6,
			},
		},
	}).mount();
}

if (testimoniesSlider) {
	new Splide(testimoniesSlider, {
		type: 'slide',
		rewind: true,
		mediaQuery: 'min',
		autoplay: true,
		interval: 5000,
		trimSpace: false,
		perMove: 1,
		fixedWidth: '290px',
		gap: '1.6rem',
		padding: { left: '1.2rem', right: '1.2rem' },
		breakpoints: {
			620: {
				padding: { left: '4%', right: '5%' },
				gap: '3.2rem',
			},
		},
	}).mount();
}

if (videoCarousel) {
	new Splide(videoCarousel, {
		type: 'loop',
		perPage: 1,
	}).mount();
}

const searchResultsPage = document.querySelector('.search-results');

if (searchResultsPage) {
	const filtersContainer =
		searchResultsPage.querySelector('.filters-container');

	if (filtersContainer) {
		const details = filtersContainer.querySelectorAll('details');
		let events = [];
		details.forEach((detail) => {
			events.push(new Filter(detail));
		});

		const cardsContainer = document.querySelector('.cards-container');
		handleFilterSearch(cardsContainer, []);
		const filterBtns = document.querySelectorAll('.filter-btn');
		const resetFilterBtns = document.querySelectorAll('.reset');

		const resultNumber = document.getElementById('result-number');

		if (cardsContainer) {
			const cards = cardsContainer.querySelectorAll('.card');

			let filters = [];

			for (const filterBtn of filterBtns) {
				filterBtn.addEventListener('click', () => {
					events.forEach((event) => {
						const el = event.returningFilter();
						filters = [...filters, el];
					});
					handleFilterSearch(cardsContainer, filters);
					let showCards = 0;
					cards.forEach((card) => {
						if (!card.classList.contains('unmatch')) {
							showCards++;
						}
					});
					if (resultNumber) {
						resultNumber.textContent = `${showCards} résultats`;
					}
				});
			}

			for (const resetFilterBtn of resetFilterBtns) {
				resetFilterBtn.addEventListener('click', () => {
					const noResults = document.querySelector('.no-results');
					if (noResults) {
						noResults.remove();
					}
					events.forEach((event) => {
						filters = [];
						cardsContainer.querySelectorAll('.card').forEach((card) => {
							card.classList.remove('unmatch');
						});
						event.resetFilters();
					});
					if (resultNumber) {
						resultNumber.textContent = `${cards.length} résultats`;
					}
				});
			}
		}
	}
}

const header = document.querySelector('header');

if (header) {
	document.addEventListener('scroll', () => {
		if (window.scrollY > 60) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});
}

const lienHero = document.querySelector('.lien-hero');

if (lienHero) {
	lienHero.addEventListener('mouseenter', () => {
		lienHero.classList.add('hovered');
	});

	lienHero.addEventListener('mouseleave', () => {
		lienHero.classList.remove('hovered');
	});
}
